import { Pipe, PipeTransform } from '@angular/core';
import {RcNumberService} from '../../../rc-utils/rc-number/rc-number.service';




@Pipe({
  name: 'rcNumber'
})
export class RcNumberPipe implements PipeTransform {

  constructor(private number: RcNumberService) {
  }

    /**
     * Convert a number to a viewable formatted string
     * @param value
     * @param number decimals
     * @param boolean round
     * @returns string
     */
  transform(value: any, decimals: number = 2, round = false): any {
    const localString: string = this.number.format(value, decimals, round).toLocaleString();

    const parts = localString.toString().split('.');
    if (parts.length < 2) {
      parts[1] = '';
    }
    if (parts[1].length < decimals) {
      for (let i = parts[1].length; i < decimals; i++) {
        parts[1] += '0';
      }
    }

    if (parts.length) {
      return `${parts[0]}.${parts[1]}`;
    }
    return parts[0];
  }

}
